import React from 'react'

const RButton = ({ buttonText = 'click', icon, ...otherprops }) => {
    return (
        <div className="flex px-4 py-2 mx-4 mt-3 cursor-pointer bg-purple-800 rounded text-white hover:bg-purple-500"
            {...otherprops}
        >
            {buttonText}
            {icon &&
                <img src={icon} alt="" className='h-4 relative top-1 left-2' />
            }
        </div>
    )
}

export default RButton
